import React, {createContext, useContext} from 'react';
import * as Yup from 'yup';
import {FormikProvider, useFormik} from 'formik';
import {useTransfersByAgentContext} from './TransfersByAgentContext';
import * as actions from "../_redux/transfersByAgentActions";
import {useDispatch} from "react-redux";

const UpdateTamalContext = createContext({});

export const useUpdateTamalContext = () => useContext(UpdateTamalContext);

export const UpdateTamalProvider = ({children}) => {
  const dispatch = useDispatch();
  const {agentId, tamalData, getTransfersByAgent} = useTransfersByAgentContext();
  const formik = useFormik({
    initialValues: {
      tamalID: tamalData.tamalID || '',
    },
    validateOnMount: true,
    validationSchema: Yup.object().shape({
      tamalID: Yup.string().required('tamalID is required'),
    }),
    onSubmit: () => {
    },
    enableReinitialize: true
  });
  const update = () => {
    dispatch(actions.updateTamal({
      agentID: parseInt(agentId) || 0,
      tamalID: formik.values.tamalID,
    }));
    getTransfersByAgent();
  };

  return (
    <UpdateTamalContext.Provider value={{formik, update}}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </UpdateTamalContext.Provider>
  );
};